export const generateHandleChange = <S extends {} = {}>(state: S, setState: (state: S) => void) => {
  return <K extends keyof S>(key: K) => (value: S[K]) =>
    setState({
      ...state,
      [key]: value
    });
};
